import { createSlice } from '@reduxjs/toolkit';

/**
 * Unsaved poll form values kept while the user edits a response collection.
 * State shape: { key, values } where key identifies the poll ('create' or poll id).
 */
const pollDraftSlice = createSlice({
  name: 'pollDraft',
  initialState: null,
  reducers: {
    saveDraft: (state, action) => action.payload, // Replace the state with the payload
    clearDraft: () => null,
  },
});

export const { saveDraft, clearDraft } = pollDraftSlice.actions;
export default pollDraftSlice.reducer;
